module.exports = __webpack_public_path__ + "img/vlab-logo.f1243def.jpg";